import MobileDetect from "mobile-detect";

export const isMobile = () => {
  const md = new MobileDetect(typeof window !== "undefined" && window.navigator.userAgent);

  return !!md.mobile();
};
